export const filterConditionIsnullIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 20 20"><ellipse cx="9.994" cy="9.996" rx="9.086" ry="9.088" stroke-width="1.817"/></svg>`,
  name: 'filter-condition-isnull',
};
